export type ViewType = 'apps' | 'clients';
export type ClientSource = 'portal' | 'ciam';

export const clientSourceOptions: Array<{ value: ClientSource; title: string }> = [
  { value: 'portal', title: 'In portal' },
  { value: 'ciam', title: 'Not in portal (only in CIAM)' },
];
